<template>
  <div class="container">
    <el-tabs v-model="activeName">
      <el-tab-pane label="操作员名单" name="/permissions/operation"></el-tab-pane>
      <el-tab-pane label="角色权限管理" name="/permissions/role"></el-tab-pane>
    </el-tabs>
    <div>
      <router-view />
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      activeName: this.$route.path,
    };
  },
  methods: {},
  mounted() {},
  watch: {
    activeName: {
      handler(val, ovl) {
        this.$router.push(val);
      },
    },
    $route(to, from) {
      //监听路由是否变化
        this.activeName = to.path;
      if (to.query.key != from.query.key) {
        this.activeName = to;
      }
    },
  },
  
};
</script>

<style lang="scss" scoped>
.handle-input {
  width: 300px;
  display: inline-block;
}

.handle-box {
  margin-bottom: 20px;
}
</style>